var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIcProfileVdoWhite(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22 5.73268C25.0934 5.73268 27.6 8.23935 27.6 11.3327C27.6 14.426 25.0934 16.9327 22 16.9327C18.9067 16.9327 16.4 14.426 16.4 11.3327C16.4 8.23935 18.9067 5.73268 22 5.73268ZM22 29.7327C29.92 29.7327 38.2667 33.626 38.2667 35.3327V38.266H5.73335V35.3327C5.73335 33.626 14.08 29.7327 22 29.7327ZM22 0.666016C16.1067 0.666016 11.3334 5.43935 11.3334 11.3327C11.3334 17.226 16.1067 21.9993 22 21.9993C27.8934 21.9993 32.6667 17.226 32.6667 11.3327C32.6667 5.43935 27.8934 0.666016 22 0.666016ZM22 24.666C14.88 24.666 0.666687 28.2393 0.666687 35.3327V43.3327H43.3334V35.3327C43.3334 28.2393 29.12 24.666 22 24.666Z",
    fill: "#ffffff"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcProfileVdoWhite);
export default __webpack_public_path__ + "static/media/ic-profile-vdo-white.dcc6a50809e20e1e3b367f7677ea7fcd.svg";
export { ForwardRef as ReactComponent };